type SetupInput = { gatewayId: string; scanId: string; address: string; name: string; widthDots: string; expectedPrinter?: { id: string; version: number } | null };
type SetupPorts = {
  post: (path: string, body: unknown) => Promise<any>;
  get: (path: string) => Promise<any>;
  pause: () => Promise<void>;
  signal: AbortSignal;
  progress: (message: string) => void;
};
// Connection tests never print. Cancellation prevents subsequent writes, not one already sent.
export async function waitForPrinterConnection(id: string, ports: SetupPorts) {
  const check = () => { if (ports.signal.aborted) throw new DOMException('Thiết lập đã dừng', 'AbortError'); };
  for (let attempt = 0; attempt < 90; attempt++) {
    check();
    const result = await ports.get(`/printing/jobs/${id}`);
    check();
    if (result.state === 'SUCCEEDED') return result;
    if (!['QUEUED', 'LEASED', 'RECEIVED', 'SENDING'].includes(result.state)) throw new Error('Không kết nối được máy in. Kiểm tra nguồn máy in, đặt gần Trạm kết nối và ngắt Bluetooth trên điện thoại nếu đang kết nối.');
    await ports.pause();
  }
  throw new Error('Trạm chưa trả lời. Kiểm tra nguồn và Wi-Fi; không cần tạo thêm máy in.');
}
export async function setupPrinter(input: SetupInput, ports: SetupPorts) {
  const check = () => { if (ports.signal.aborted) throw new DOMException('Thiết lập đã dừng', 'AbortError'); };
  check(); ports.progress('Đang kiểm tra máy in…');
  const path = `/printing/gateways/${input.gatewayId}/commands`;
  const probe = await ports.post(path, { kind: 'PROBE', address: input.address, scanId: input.scanId, requestKey: crypto.randomUUID() });
  await waitForPrinterConnection(probe.id, ports); check();
  ports.progress('Đang kết nối Bluetooth…');
  const connection = await ports.post(path, { kind: 'CONNECT', address: input.address, scanId: input.scanId, probeId: probe.id, requestKey: crypto.randomUUID() });
  await waitForPrinterConnection(connection.id, ports); check();
  ports.progress('Đã kết nối. Đang lưu máy in…');
  return ports.post('/printing/printers/connect-and-save', { ...input, expectedPrinter: input.expectedPrinter ?? null, probeId: probe.id, connectionId: connection.id });
}
export async function reconnectPrinter(printerId: string, ports: SetupPorts) {
  if (ports.signal.aborted) throw new DOMException('Kết nối đã dừng', 'AbortError');
  ports.progress('Đang kết nối lại máy in đã lưu…');
  const task = await ports.post(`/printing/printers/${printerId}/reconnect`, { requestKey: crypto.randomUUID() });
  return waitForPrinterConnection(task.id, ports);
}
